import { render, staticRenderFns } from "./UserDesigns.vue?vue&type=template&id=65fbb0a0&scoped=true&"
import script from "./UserDesigns.vue?vue&type=script&lang=ts&"
export * from "./UserDesigns.vue?vue&type=script&lang=ts&"
import style0 from "./UserDesigns.vue?vue&type=style&index=0&id=65fbb0a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fbb0a0",
  null
  
)

export default component.exports